import { useMemo } from "react";

import { getCountries } from "utils/continents";

export function useCountryValidator(externalValidCodes?: Set<string>) {
  const countries = getCountries();

  const validCodes = useMemo(() => {
    // If external codes are provided, use those
    if (externalValidCodes) {
      return externalValidCodes;
    }

    return new Set(countries.map((c) => c.code));
  }, [countries, externalValidCodes]);

  return { validCodes };
}
